exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-jsx": () => import("./../../../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */),
  "component---src-pages-recuperar-contrasena-jsx": () => import("./../../../src/pages/recuperar-contrasena.jsx" /* webpackChunkName: "component---src-pages-recuperar-contrasena-jsx" */)
}

